import { poly_clip_to_box } from './poly_clip';

import { avp } from "@adsk/lmv";

const v41 = new THREE.Vector4();
const v42 = new THREE.Vector4();
const v43 = new THREE.Vector4();

/**
 * @param v {THREE.Vector3}
 * @param m {THREE.Matrix4}
 * @param out {THREE.Vector4}
 */
function applyProjection(v, m, out) {

  //Similar to Vector3.applyProjection, but without perspective divide (leaves output in clip space).

  let x = v.x,y = v.y,z = v.z;

  let e = m.elements;

  out.x = e[0] * x + e[4] * y + e[8] * z + e[12];
  out.y = e[1] * x + e[5] * y + e[9] * z + e[13];
  out.z = e[2] * x + e[6] * y + e[10] * z + e[14];
  out.w = e[3] * x + e[7] * y + e[11] * z + e[15];
}

/**
 * @param {BufferGeometry} geom
 * @param {Matrix4} mvpMtx
 * @param {Box3} ndcBox
 */
export function geomIntersectsNDC(geom, mvpMtx, ndcBox) {

  let contains = true;
  let intersects = false;

  if (geom.isLine) {
    avp.VertexEnumerator.enumMeshLines(geom, (vA, vB) => {

      //Get the line into NDC coordinates and do the
      //clipping check by faking a triangle.
      applyProjection(vA, mvpMtx, v41);
      applyProjection(vB, mvpMtx, v42);

      let pIn = [v41, v42];
      let result = poly_clip_to_box(pIn, ndcBox);

      if (result !== avp.CONTAINS) {
        contains = false;
      }

      if (result !== avp.OUTSIDE) {
        intersects = true;
      }

      //TODO: we can early out here if we can definitively reject containment or detect intersection
    });
  } else {

    avp.VertexEnumerator.enumMeshTriangles(geom, (vA, vB, vC) => {

      //Get the triangle into NDC coordinates and do the
      //clipping check.
      applyProjection(vA, mvpMtx, v41);
      applyProjection(vB, mvpMtx, v42);
      applyProjection(vC, mvpMtx, v43);

      let pIn = [v41, v42, v43];
      let result = poly_clip_to_box(pIn, ndcBox);

      if (result !== avp.CONTAINS) {
        contains = false;
      }

      if (result !== avp.OUTSIDE) {
        intersects = true;
      }

      //TODO: we can early out here if we can definitively reject containment or detect intersection
    });
  }

  if (contains) {
    return avp.CONTAINS;
  } else if (intersects) {
    return avp.INTERSECTS;
  } else {
    return avp.OUTSIDE;
  }
}